var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeavePolicyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55.024,
    height: 55,
    viewBox: "0 0 55.024 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{filter:url(#h);}.c{filter:url(#e);}.d{filter:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#D23B7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23B7D"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 0,
    y: 5.253,
    width: 44.174,
    height: 44.174,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 7,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#c2afff",
    floodOpacity: 0.78
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 0,
    y: 16.771,
    width: 55.022,
    height: 38.229,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 7,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#c2afff",
    floodOpacity: 0.702
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    x: 1.576,
    y: 0,
    width: 53.448,
    height: 52.771,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 7,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "i"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#c2afff",
    floodOpacity: 0.722
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "i"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 10.673)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.58)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, -18, -16.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.8,146.521l1.379-.726L6.8,145.07l.831-1.318-1.557.061.061-1.557-1.318.831-.726-1.379-.726,1.379-1.318-.831.061,1.557-1.557-.061.831,1.318L0,145.8l1.379.726-.831,1.318,1.557-.061-.061,1.557,1.318-.831.726,1.379.726-1.379,1.318.831-.061-1.557,1.557.061Zm-2.708,1.318A2.043,2.043,0,1,1,6.13,145.8,2.043,2.043,0,0,1,4.087,147.839Z",
    transform: "translate(18 -125.46)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 17.098)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, -18, -27.77)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.117,452.339a1.982,1.982,0,0,1-2.529,0,3.087,3.087,0,0,0-3.812,0,1.982,1.982,0,0,1-2.529,0,2.978,2.978,0,0,0-1.906-.659,2.978,2.978,0,0,0-1.906.659,1.876,1.876,0,0,1-1.265.456,1.875,1.875,0,0,1-1.265-.456A2.978,2.978,0,0,0,0,451.68v1.115a1.876,1.876,0,0,1,1.265.456,2.978,2.978,0,0,0,1.906.659,2.978,2.978,0,0,0,1.906-.659,1.876,1.876,0,0,1,1.265-.456,1.876,1.876,0,0,1,1.265.456,3.086,3.086,0,0,0,3.811,0,1.982,1.982,0,0,1,2.529,0,3.086,3.086,0,0,0,3.812,0,1.876,1.876,0,0,1,1.265-.456V451.68A2.978,2.978,0,0,0,17.117,452.339Z",
    transform: "translate(18 -423.91)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.577 0.327)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "matrix(1, 0, 0, 1, -19.58, -11)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M59.3,4.386A6.084,6.084,0,0,0,56.355,1.43l.263-.722L55.57.327l-.263.722a6.139,6.139,0,0,0-7.325,3.83l-.225.618.647.12A9.591,9.591,0,0,1,51.374,6.7l.13.073h.206a5.788,5.788,0,0,1,1.448.184l-2.6,7.135-.2,0a15.337,15.337,0,0,0-7.935,2.2,4.892,4.892,0,0,1,.97.56c.326.229.36.253.624.253s.3-.024.623-.253a4.2,4.2,0,0,1,5.094,0c.326.229.36.253.624.253s.3-.024.623-.253a4.2,4.2,0,0,1,5.094,0c.326.229.36.253.624.253s.3-.024.624-.253a4.893,4.893,0,0,1,.97-.56,15.307,15.307,0,0,0-6.573-2.136l2.479-6.812a5.79,5.79,0,0,1,1.27.826l.114.1.147.027a9.592,9.592,0,0,1,2.97,1.081l.573.324.225-.618A6.09,6.09,0,0,0,59.3,4.386Z",
    transform: "translate(-22.85 10.67)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeavePolicyIcon);
export default __webpack_public_path__ + "static/media/LeavePolicyIcon.22660f118e5769b45d172113482ce26a.svg";
export { ForwardRef as ReactComponent };